import { nexus } from "../../exports/nexus.js";
import {
  runWithMicrotask,
  runWithMacrotask,
  runWithAnimationFrame,
  runWithRenderSlice,
} from "./async/promise";

nexus().grcore.assignNamespace({
  runWithMicrotask,
  runWithMacrotask,
  runWithAnimationFrame,
  runWithRenderSlice,
});
